import { render, staticRenderFns } from "./SpecialSms.vue?vue&type=template&id=849c0bc8&"
import script from "./SpecialSms.vue?vue&type=script&lang=js&"
export * from "./SpecialSms.vue?vue&type=script&lang=js&"
import style0 from "./SpecialSms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports